import type { DoseUnit } from '@baby-tracker/validation';
import {
    gramsToMass,
    millimetresToLength,
    type MassDisplayUnit,
    type LengthDisplayUnit,
} from '@baby-tracker/validation';

export function doseToMinor(value: number, unit: DoseUnit): number {
    return unit === 'ml' || unit === 'tablet' ? Math.round(value * 10) : Math.round(value);
}

export function formatStoredDose(amount: number, unit: DoseUnit): string {
    const major = unit === 'ml' || unit === 'tablet' ? amount / 10 : amount;
    const text = Number.isInteger(major) ? String(major) : major.toFixed(1);
    if (unit === 'tablet') {
        return major === 1 ? `${text} tablet` : `${text} tablets`;
    }
    return `${text} ${unit}`;
}

export function formatWeight(grams: number, unit: MassDisplayUnit): string {
    const value = gramsToMass(grams, unit);
    return `${value} ${unit}`;
}

export function formatLength(millimetres: number, unit: LengthDisplayUnit): string {
    const value = millimetresToLength(millimetres, unit);
    return `${value} ${unit}`;
}
